import http from "../../plugins/http";

const state = {
  id: null,
  items: [],
  req_status: 0,
  request_schedule: [],
  no_of_months: 0,
  upfront_amt: 0,
  customer: {},
  bs_transaction_id: null,
  upfront_paid: null,
  cred_plus_upfront: 0,
  eligibility_data: null,
  creditclan_request_id: null,
  stages: {},
  stage: 0,
  analysis_completed: [],
  email_verified: 0,
  offer: null,
  slug: null,
  whatsapp_order: 0
};

const getters = {
  upfrontAmount(state) {
    if (state.offer && state.offer.upfront) return state.offer.upfront;
    return state.upfront_amt
  },
  monthlyAmount(state) {
    if (state.offer && state.offer.monthly_repayment) return state.offer.monthly_repayment;
    return state.monthly_amt
  },
  noOfMonths(state) {
    if (state.offer && state.offer.duration) return state.offer.duration;
    return state.no_of_months
  },
  amountToPay(state) {
    if (state.offer && state.offer.upfront) {
      return state.offer.upfront
    }
    if (state.no_of_months) {
      return state.upfront_amt
    } else {
      return state.cred_plus_upfront
    }
  },
  nextPayment(state) {
    const unpaidSchedules = state.request_schedule.filter(s => {
      return (new Date(Date.now()) > new Date(s.date) && +s.amount_paid < +s.amount)
    });
    const debt = unpaidSchedules.reduce((acc, s) => {
      acc += +s.amount - +s.amount_paid;
      return acc;
    }, 0);
    const next = state.request_schedule.find(s => {
      return (new Date(Date.now()) < new Date(s.date) && +s.amount_paid < +s.amount)
    });
    const amount = (next ? +next.amount - +next.amount_paid : 0) + debt;
    return next ? ({
      amount,
      date: next.date,
      ids: [...unpaidSchedules.map(s => s.id), next.id]
    }) : {
      amount,
      date: unpaidSchedules[unpaidSchedules.length - 1] ? unpaidSchedules[unpaidSchedules.length - 1].date : null,
      ids: unpaidSchedules.map(s => s.id)
    };
  },
  amountDue(state) {
    return state.request_schedule.reduce((acc, schedule) => {
      const today = new Date(Date.now());
      const date = new Date(schedule.date);
      if (today > date) {
        acc += +schedule.amount - +schedule.amount_paid
      }
      return acc;
    }, 0)
  },
  paymentTillDate(state) {
    return state.request_schedule.reduce((acc, schedule) => {
      acc += +schedule.amount_paid;
      return acc;
    }, 0);
  },
  balance(state) {
    return state.request_schedule.reduce((acc, schedule) => {
      if (schedule.amount_paid) {
        acc += +schedule.amount - +schedule.amount_paid
      } else {
        acc += +schedule.amount
      }
      return acc;
    }, 0)
  },
  previewItems(state) {
    return state.items.slice(0, 2);
  },
  doAnalysis(state, getters, rootState) {
    return getters.credit && (rootState.merchant.partnership === 1 || rootState.merchant.eligibility === 1 || rootState.merchant.insurance === 1);
  },
  analysisDone(state) {
    return state.stage > 3;
  },
  doCollection(state, getters, rootState) {
    return getters.credit && rootState.merchant.partnership === 0 && (rootState.merchant.collection === 1 || rootState.merchant.insurance === 1);
  },
  collectionDone(state) {
    return state.analysis_completed.includes('repayment');
  },
  emailVerified(state) {
    return (state.customer.email && state.email_verified === 1) || state.whatsapp_order === 1
  },
  upfrontPaid() {
    return state.upfront_paid === 1
  },
  credit() {
    return +state.no_of_months > 0
  },
};

const mutations = {
  set: (state, data) => {
    Object.keys(data).forEach(key => {
      state[key] = data[key];
    })
  },
  clear: (state) => {
    Object.keys(state).forEach(key => {
      state[key] = null;
    })
  }
};

const actions = {
  async load({ commit, state }, id) {
    try {
      const {
        data: { data: { customer, merchant, ...request } }
      } = await http.get(`https://sellbackend.creditclan.com/merchantclanbackend/public/index.php/api/request_only/${ id || state.id }`);
      if (+request.no_of_months > 0) {
        const res = await http.post('https://sellbackend.creditclan.com/schoolcredit/public/index.php/api/offer/stages', { amount: request.cred_plus_upfront });
        request.stages = res.data
      } else request.stages = null
      commit('set', { ...request, merchant_id: merchant.id, customer: { ...JSON.parse(JSON.stringify(customer)) } });
      commit('customer/prefill', customer, { root: true });
    } catch (e) {
      console.log(e)
    }
  },
  async resolveId(_, slug) {
    const { data: { data } } = await http.get(`/3/slug/${ slug }`);
    return data;
  }
};

const request = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};

export default request;
